import * as XLSX from 'xlsx';

let _otelAdi = 'HotelFlow';
export function setExportOtelAdi(ad) { _otelAdi = ad || 'HotelFlow'; }
function getOtelAdi() { return _otelAdi; }

function simdi() {
  var d = new Date();
  var pad = function(n) { return String(n).padStart(2, '0'); };
  return (
    pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() +
    ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
  );
}

/**
 * Gerçek .xlsx dosyası indir. Otel adı ve rapor başlığı otomatik eklenir.
 * @param {string} filename
 * @param {string} sheetName
 * @param {string[]} headers
 * @param {any[][]} rows
 */
export function downloadExcel(filename, sheetName, headers, rows) {
  var otelAdi = getOtelAdi().toUpperCase();
  var tarih = simdi();
  var cols = headers.length;
  var raporAdi = (sheetName || filename).toUpperCase();

  // Başlık bölümü (4 satır) + header + data
  var titleRows = [
    [otelAdi,        ...Array(cols - 1).fill('')],
    [raporAdi,       ...Array(cols - 1).fill('')],
    ['Rapor tarihi: ' + tarih, ...Array(cols - 1).fill('')],
    Array(cols).fill(''),   // boş ayırıcı
  ];

  var ws = XLSX.utils.aoa_to_sheet([...titleRows, headers, ...rows]);

  // Başlık satırlarını tüm sütunlara yayınla (merge)
  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: cols - 1 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: cols - 1 } },
    { s: { r: 2, c: 0 }, e: { r: 2, c: cols - 1 } },
  ];

  // Satır yükseklikleri — başlık satırlarını biraz daha yüksek yap
  ws['!rows'] = [
    { hpx: 22 },  // otel adı
    { hpx: 18 },  // rapor adı
    { hpx: 14 },  // tarih
    { hpx: 8 },   // boş
    { hpx: 16 },  // header
  ];

  // Sütun genişlikleri (data+header bazlı)
  ws['!cols'] = headers.map(function(h, i) {
    var maxLen = rows.reduce(function(max, r) {
      return Math.max(max, String(r[i] ?? '').length);
    }, h.length);
    return { wch: Math.max(maxLen, 12) };
  });

  var wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName || 'Sayfa1');
  XLSX.writeFile(wb, filename.endsWith('.xlsx') ? filename : filename + '.xlsx');
}

/**
 * Yeni pencerede temiz, premium tablo açıp yazdır.
 * @param {string} title
 * @param {string[]} headers
 * @param {any[][]} rows
 * @param {string} [subtitle]
 */
export function printTable(title, headers, rows, subtitle) {
  var otelAdi = getOtelAdi();
  var tarih = simdi();

  var thCells = headers.map(function(h) {
    return '<th>' + escHtml(h) + '</th>';
  }).join('');

  var bodyRows = rows.map(function(r, ri) {
    var tds = r.map(function(c) {
      return '<td>' + escHtml(String(c ?? '')) + '</td>';
    }).join('');
    return '<tr class="' + (ri % 2 === 0 ? 'even' : 'odd') + '">' + tds + '</tr>';
  }).join('');

  var html = [
    '<!DOCTYPE html>',
    '<html lang="tr"><head>',
    '<meta charset="UTF-8">',
    '<title>' + escHtml(otelAdi + ' — ' + title) + '</title>',
    '<style>',
    '* { box-sizing: border-box; margin: 0; padding: 0; }',
    'body { font-family: "Segoe UI", Arial, sans-serif; background: #f8fafc; color: #1e293b; }',

    /* ── Header ── */
    '.report-header {',
    '  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);',
    '  color: white;',
    '  padding: 28px 36px 22px;',
    '  page-break-inside: avoid;',
    '}',
    '.otel-name {',
    '  font-size: 11px; font-weight: 800; letter-spacing: 0.25em;',
    '  text-transform: uppercase; opacity: 0.6; margin-bottom: 6px;',
    '}',
    '.report-title {',
    '  font-size: 22px; font-weight: 900; letter-spacing: -0.02em;',
    '  text-transform: uppercase; line-height: 1.1; margin-bottom: 6px;',
    '}',
    '.report-meta {',
    '  font-size: 10px; opacity: 0.55; font-weight: 600; letter-spacing: 0.05em;',
    '}',

    /* ── Tablo ── */
    '.table-wrap { padding: 28px 36px 36px; }',
    '.subtitle { font-size: 11px; font-weight: 700; color: #64748b;',
    '  text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 14px; }',
    'table { border-collapse: collapse; width: 100%; font-size: 11px; }',
    'thead tr { background: #f1f5f9; }',
    'th { padding: 9px 12px; text-align: left; font-weight: 800; font-size: 9px;',
    '  text-transform: uppercase; letter-spacing: 0.12em; color: #475569;',
    '  border-bottom: 2px solid #e2e8f0; white-space: nowrap; }',
    'td { padding: 8px 12px; border-bottom: 1px solid #f1f5f9;',
    '  font-size: 11px; font-weight: 500; color: #334155; }',
    'tr.even td { background: #ffffff; }',
    'tr.odd td { background: #f8fafc; }',
    'tr:last-child td { border-bottom: none; }',

    /* ── Footer ── */
    '.report-footer {',
    '  padding: 12px 36px; border-top: 1px solid #e2e8f0;',
    '  display: flex; justify-content: space-between; align-items: center;',
    '}',
    '.footer-left { font-size: 9px; color: #94a3b8; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; }',
    '.footer-right { font-size: 9px; color: #94a3b8; font-weight: 600; }',

    /* ── Yazdır butonu ── */
    '.print-btn-bar { padding: 20px 36px; text-align: right; }',
    '.print-btn { padding: 10px 28px; background: #1e293b; color: white; border: none;',
    '  border-radius: 10px; cursor: pointer; font-size: 12px; font-weight: 800;',
    '  letter-spacing: 0.05em; text-transform: uppercase; transition: background .2s; }',
    '.print-btn:hover { background: #0f172a; }',
    '@media print {',
    '  body { background: white; }',
    '  .print-btn-bar { display: none; }',
    '  .report-header { -webkit-print-color-adjust: exact; print-color-adjust: exact; }',
    '  thead tr { -webkit-print-color-adjust: exact; print-color-adjust: exact; }',
    '}',
    '</style>',
    '</head><body>',

    /* ── Header bölümü ── */
    '<div class="report-header">',
    '  <div class="otel-name">' + escHtml(otelAdi) + '</div>',
    '  <div class="report-title">' + escHtml(title) + '</div>',
    subtitle ? '  <div class="report-meta">' + escHtml(subtitle) + '</div>' : '',
    '</div>',

    /* ── Tablo bölümü ── */
    '<div class="table-wrap">',
    subtitle ? '' : '',
    '<table>',
    '<thead><tr>' + thCells + '</tr></thead>',
    '<tbody>' + bodyRows + '</tbody>',
    '</table>',
    '</div>',

    /* ── Footer ── */
    '<div class="report-footer">',
    '  <span class="footer-left">' + escHtml(otelAdi) + ' · ' + escHtml(title) + '</span>',
    '  <span class="footer-right">Oluşturuldu: ' + escHtml(tarih) + '</span>',
    '</div>',

    /* ── Yazdır butonu ── */
    '<div class="print-btn-bar">',
    '  <button class="print-btn" onclick="window.print()">🖨 Yazdır</button>',
    '</div>',

    '</body></html>',
  ].join('\n');

  var w = window.open('', '_blank', 'width=1020,height=700');
  if (!w) { alert('Popup engelleyici aktif. Lütfen popup\'lara izin verin.'); return; }
  w.document.write(html);
  w.document.close();
  setTimeout(function() { w.print(); }, 400);
}

function escHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
